// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c5g4nUJYRQEQEA {
  display: inline-flex;
  position: relative;
  box-sizing: border-box;
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px) var(--ds-space-075, 6px) var(--ds-space-075, 6px);
  overflow: hidden;
  border: none;
  border-radius: var(--ds-border-radius-100, 3px);
  text-decoration: none;
}
.rz5GQDmxKmVKbn {
  background: var(--ds-background-discovery, #f3f0ff);
}
.rz5GQDmxKmVKbn:hover {
  background: var(--ds-background-discovery-hovered, #dfd8fd);
}
.rz5GQDmxKmVKbn .tB7UTnfpqhZDNY {
  background: var(--ds-background-discovery-bold, #6e5dc6);
}
.rz5GQDmxKmVKbn .uUOFo5rigKuNbQ svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.rz5GQDmxKmVKbn .sxIwbjkBYpc67v {
  color: var(--ds-text-subtle, #44546f);
}
.IxuXbF4BqDsI81 {
  background: var(--ds-background-discovery-bold, #6e5dc6);
}
.IxuXbF4BqDsI81:hover {
  background: var(--ds-background-discovery-bold-hovered, #583f68);
}
.IxuXbF4BqDsI81:hover .uUOFo5rigKuNbQ svg {
  color: var(--ds-icon-discovery, #583f68);
}
.IxuXbF4BqDsI81 .tB7UTnfpqhZDNY {
  background: var(--ds-surface-raised, #ffffff);
}
.IxuXbF4BqDsI81 .uUOFo5rigKuNbQ svg {
  color: var(--ds-icon-discovery, #8270db);
}
.IxuXbF4BqDsI81 .sxIwbjkBYpc67v {
  color: var(--ds-text-inverse, #ffffff);
}
.IKjhNcOl5SiiiU {
  margin: var(--ds-space-0, 0);
  background: linear-gradient(97.78deg, var(--ds-background-accent-purple-bolder, #4423a3) 17.5%, var(--ds-background-accent-magenta-subtle, #aa63cb) 113.39%);
}
.IKjhNcOl5SiiiU:hover {
  background: linear-gradient(270deg, var(--ds-background-accent-purple-bolder, #403294) 0%, var(--ds-background-neutral-bold-pressed, #172b4d) 100%);
}
.IKjhNcOl5SiiiU .uUOFo5rigKuNbQ svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.IKjhNcOl5SiiiU .sxIwbjkBYpc67v {
  color: var(--ds-text-inverse, #ffffff);
}
.tB7UTnfpqhZDNY {
  width: 20px;
  height: 20px;
  margin-right: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-050, 2px);
}
.p7851IQH7y2U37 {
  display: flex;
  width: 100%;
}
.odSkdpmhAc91ql {
  justify-content: center;
}
.ohoZ6UGkC3oiCc {
  justify-content: left;
}
.uUOFo5rigKuNbQ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
}
`, ""]);
// Exports
export var upgradePromptButton = `c5g4nUJYRQEQEA`;
export var upgradePromptButtonLightTheme = `rz5GQDmxKmVKbn`;
export var upgradePromptButtonIconBackground = `tB7UTnfpqhZDNY`;
export var upgradePromptButtonIcon = `uUOFo5rigKuNbQ`;
export var upgradePromptButtonCTA = `sxIwbjkBYpc67v`;
export var upgradePromptButtonDarkTheme = `IxuXbF4BqDsI81`;
export var upgradePromptButtonGradientTheme = `IKjhNcOl5SiiiU`;
export var upgradePromptFitContainer = `p7851IQH7y2U37`;
export var upgradePromptJustifyCenter = `odSkdpmhAc91ql`;
export var upgradePromptJustifyLeft = `ohoZ6UGkC3oiCc`;
export default ___CSS_LOADER_EXPORT___;
